import React from 'react';

const NoPage = () => (
  <div>
    <h1>PageNote found</h1>
  </div>
);

export default NoPage;
